module.exports = __webpack_public_path__ + "media/stylesheets/images/raudi_krossinn_big-78a8ae547c44ee731b9137984edca0b4.gif";